import { ViewStyle } from "react-native";
import GatheringPreviewCard from "src/components/GatheringPreviewRow/components/GatheringPreviewCard";
import { GatheringPreviewCardProps } from "src/components/GatheringPreviewRow/components/GatheringPreviewCard/types";
import OpacityView from "src/components/OpacityView";
import RoundedButton from "src/components/RoundedButton";
import hasValidGatheringAccess from "src/helpers/gatheringHelpers/hasValidGatheringAccess";
import useRouter from "src/hooks/useRouter";
import { paddingSmall } from "src/styles/spacing";
import { SearchModalPaddingHorizontal } from "../constants/SearchModalStyleConstants";
import { SearchGatheringType } from "../types";

const DefaultDetails = [
	"community",
	"numParticipants",
	"numPhotos",
] satisfies GatheringPreviewCardProps["details"];
const CardStyle: ViewStyle = {
	width: "100%",
	height: "100%",
};

const SearchGathering = ({ gathering }: { gathering: SearchGatheringType }) => {
	const router = useRouter();
	return (
		<OpacityView
			testID="SearchGathering"
			style={{
				width: "100%",
				height: 150,
				paddingVertical: paddingSmall,
				paddingHorizontal: SearchModalPaddingHorizontal,
			}}
		>
			{hasValidGatheringAccess(gathering) ? (
				<GatheringPreviewCard
					gathering={gathering}
					details={DefaultDetails}
					style={CardStyle}
				/>
			) : (
				<GatheringPreviewCard
					gathering={gathering}
					details={[
						({ item }) => {
							return (
								<RoundedButton
									sizeVariant="Skinny"
									onPress={() => {
										router.push(`/album/${item.refCode}?join=true`);
									}}
								>
									Join album
								</RoundedButton>
							);
						},
					]}
					style={CardStyle}
				/>
			)}
		</OpacityView>
	);
};
export default SearchGathering;
